<template>
  <section>
    <v-img src="/images/banner1.jpg" class="banner" alt="A Escola" aspect-ratio="8.0">
      <div class="fill-height fundo">
        <h1>{{value}}</h1>
      </div>
    </v-img>
  </section>
</template>

<script>
export default {
  data: () => ({}),
  props: ["value"]
};
</script>

<style lang="scss" scoped>
// google font subsetting, see Heydon Pickering's: http://www.sitepoint.com/joy-of-subsets-web-fonts/

h1 {
  font-family: Pacifico;
  opacity: 0.95;
  color: white;
  text-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9,
    0 5px 0 #aaa, 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
    0 5px 10px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.2),
    0 20px 20px rgba(0, 0, 0, 0.15);
}

.fundo {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(32, 150, 243, 0.8),
    rgba(32, 150, 243, 0.8) 5px,
    rgba(32, 150, 243, 1) 5px,
    rgba(32, 150, 243, 1) 10px
  );
}

// XS
@media screen and (max-width: 600px) {
  h1 {
    padding: 12px 0;
    font-size: 50px;
  }
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
  h1 {
    padding: 17px 0;
    font-size: 60px;
  }
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
  h1 {
    padding: 20px 0;
    font-size: 70px;
  }
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
  h1 {
    padding: 40px 0;
    font-size: 80px;
  }
}

// XL
@media screen and (min-width: 1905px) {
  h1 {
    padding: 45px 0;
    font-size: 90px;
  }
}
</style>

